<p class="btn-group btn-group-sm workingDays">
    <mat-button-toggle-group appearance="legacy" hideMultipleSelectionIndicator multiple
                             name="workingDays" aria-label="working days" 
                             [formControl]="workingDaysCtrl">
        <mat-button-toggle value="monday">{{'monday' | translate}}</mat-button-toggle>
        <mat-button-toggle value="tuesday">{{'tuesday' | translate}}</mat-button-toggle>
        <mat-button-toggle value="wednesday">{{'wednesday' | translate}}</mat-button-toggle>
        <mat-button-toggle value="thursday">{{'thursday' | translate}}</mat-button-toggle>
        <mat-button-toggle value="friday">{{'friday' | translate}}</mat-button-toggle>
        <mat-button-toggle value="saturday">{{'saturday' | translate}}</mat-button-toggle>
        <mat-button-toggle value="sunday">{{'sunday' | translate}}</mat-button-toggle>
      </mat-button-toggle-group>
</p>

